import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism'

import styles from '../../Products.module.scss'

import {
  Check as CheckIcon,
  Xml as CodeIcon,
  HelpCircle as HelpIcon,
  Document as DocumentIcon,
} from '../../../../icons'
import ResultBlock from 'components/elements/blocks/ResultBlock'
import TabsList from 'components/elements/tabs/TabsList'
import CopyButton from 'components/elements/buttons/CopyButton'

import {
  UnblockerCommandTypes,
  UnblockerUsageCodeExamples,
} from 'utils/unblocker/unblockerConstants'

import { selectScrapperApiKey } from 'store/user/selectors'

interface IUnblockerUsageResultProps {
  selectedUsageType: string
  daysValue: string
}

const UnblockerUsageResult: React.FC<IUnblockerUsageResultProps> = (props) => {
  const { selectedUsageType, daysValue } = props

  const [selectedCommandTypeIndex, setCommandTypeIndex] = useState(0)

  const scrapperApiKey = useSelector(selectScrapperApiKey)

  const handleCodeTypeChange = (index: number) => {
    setCommandTypeIndex(index)
  }

  const commandTypeValue = UnblockerCommandTypes[selectedCommandTypeIndex].value

  const getCurrentCodeExample = () => {
    // @ts-ignore
    return UnblockerUsageCodeExamples[selectedUsageType][commandTypeValue]
  }

  const currentCodeExample = getCurrentCodeExample()

  const getCodeString = () => {
    let codeString = currentCodeExample

    codeString = codeString
      .replace('{{placeholder_params}}', '')
      .replace('{{days}}', daysValue)
      .replace('{{X-SOAX-API-Secret}}', scrapperApiKey)

    return codeString
  }

  const codeString = getCodeString()

  const activeLanguage =
    commandTypeValue === 'curl' || commandTypeValue === 'node'
      ? 'javascript'
      : commandTypeValue

  return (
    <div>
      <div
        className={`
          ${styles.blockBackgroundHeader}
        `}
      >
        <div>
          <div className={styles.headerIconWrapper}>
            <CodeIcon />
          </div>

          <span className={styles.blockTitle}>Output</span>
        </div>

        <div className={styles.headerCheck}>
          <div className={styles.checkIconWrapper}>
            <CheckIcon />
          </div>
          Updated
        </div>
      </div>

      <ResultBlock
        slot={
          <div className={styles.resultBlockTabsWrapper}>
            <TabsList
              items={UnblockerCommandTypes}
              itemClassName={styles.resultBlockTabItem}
              onChange={handleCodeTypeChange}
              activeTabIndex={selectedCommandTypeIndex}
            />
          </div>
        }
        className={styles.resultBlock}
        contentClassName={styles.unblockerResultBlock}
      >
        <div className={styles.unblockerResultBlockContent}>
          <SyntaxHighlighter language={activeLanguage} style={atomDark}>
            {codeString}
          </SyntaxHighlighter>
        </div>
      </ResultBlock>

      <div className={styles.controls}>
        <CopyButton text={codeString} className={styles.rowBtn}>
          Copy code
        </CopyButton>
      </div>

      <a
        className={styles.guideLink}
        href="https://docs.soax.com/#b779ee30-4778-4dec-9eb1-a41591f3530d"
        target={'_blank'}
        rel={'noopener noreferrer'}
      >
        <div className={styles.bookIconWrapper}>
          <HelpIcon />
        </div>{' '}
        <span>Web Data API documentation - Read in Postman</span>
      </a>

      <a
        className={styles.guideLink}
        href="https://soax.com/web-data-api"
        target={'_blank'}
        rel={'noopener noreferrer'}
      >
        <div className={styles.bookIconWrapper}>
          <DocumentIcon />
        </div>{' '}
        <span>Web Data API product page - Read more</span>
      </a>
    </div>
  )
}

export default UnblockerUsageResult
